// This file provides a mock browser API for web mode
// and exports the real webextension-polyfill when in extension mode

const mockBrowser = {
  runtime: {
    getURL: () => '',
    onMessage: {
      addListener: () => {},
    },
    sendMessage: async () => {},
  },
  storage: {
    local: {
      get: async () => ({}),
      set: async () => {},
      remove: async () => {},
    },
  },
}

export default async function getBrowser() {
  // Only import the real browser polyfill when in extension mode
  if (BUILD_TARGET === 'extension') {
    const browser = (await import('webextension-polyfill')).default
    return browser
  }

  // Return mock implementation for web mode
  return mockBrowser
}
